export default class BaseError extends Error {
  name = 'BaseError'
  public context: Record<string, any>
  constructor(...args: any[]) {
    super(...args)
    this.context = {}
  }
}
